var map = {
	"./climate_agriculture_1_precipitation.jpg": 150,
	"./climate_agriculture_2_density.jpg": 151,
	"./climate_agriculture_3_cropViability.jpg": 152,
	"./climate_water_1_politicalBordersWatersheds_700px.jpg": 153,
	"./climate_water_2_watershedsStress.jpg": 154,
	"./climate_water_3_hydroelectricityFlowAlteration.jpg": 155,
	"./climate_water_floodZones.jpg": 156,
	"./climate_workplacePollutants_1_landWaterAirPollutants.jpg": 157,
	"./climate_workplacePollutants_2_overlandPollutants.jpg": 158,
	"./climate_workplacePollutants_3_airPollutants.jpg": 159,
	"./climate_workplacePollutants_4_surfaceWaterPollutants.jpg": 160,
	"./climate_workplacePollutants_5_criteriaSirContainmentPollutants.jpg": 161,
	"./climate_workplace_1_powerProductionSites.jpg": 162,
	"./climate_workplace_2_manufacturingSites.jpg": 163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91;